import { useCallback } from 'react';
import { DateTime, DateTimeService, useDateTimeLocalizationInfo } from '@mews/framework';

export const useLocalizeDateTime = () => {
    const localizationInfo = useDateTimeLocalizationInfo();

    return useCallback(
        (dateTime: DateTime) => DateTimeService.toString(dateTime, localizationInfo),
        [localizationInfo]
    );
};
